import { IRequisitionListFilters } from './forms.types';

export const DEFAULT_REQUISITION_LIST_FILTERS: IRequisitionListFilters = {
  search: '',
  periodix: '',
  cycleix: '',
  costcenterix: '',
  stateix: '',
  aiassisted: '',
  fromdate: '',
  todate: '',
  page: 1,
  pagesize: 20,
};

export const AI_ASSIST_OPTIONS = [
  { value: '', label: 'All' },
  { value: '1', label: 'AI Assisted' },
  { value: '0', label: 'Manual' },
];
